import React from 'react'
import { Trans } from '@lingui/react'
import CenterBox from './CenterBox.js'

const ThanksPage = () => (
  <CenterBox>
    <Trans>Thanks for helping us get better!</Trans>
  </CenterBox>
)

export default ThanksPage



// WEBPACK FOOTER //
// ./src/components/ThanksPage.js